import {VehicleOwnershipEnum} from '@/services/api-clients';

export function driverVehicleOwnershipIconFilter(type: VehicleOwnershipEnum) {
  switch(type) {
    case VehicleOwnershipEnum.OwnedOrRented: return 'mdi-account-key';
    case VehicleOwnershipEnum.RentedFromCarrier: return 'mdi-car-key';
    case VehicleOwnershipEnum.OwnedByCarrier: return 'mdi-taxi';
  }
}
